import { addProp } from "@pnp/odata";
import { _List } from "../lists/types";
import { Folder } from "./types";
addProp(_List, "rootFolder", Folder, "rootFolder");
//# sourceMappingURL=list.js.map